export default __webpack_public_path__ + "static/media/40235.1ed47a11.jpg";